import Rails from '@rails/ujs';


document.addEventListener('DOMContentLoaded', function() {

  var search = document.getElementById('ratings-search');
  var bulk = document.getElementById('bulk-ratings');
  if (!search || !bulk) return;

  var button = bulk.querySelector('button');
  var selectAll = document.getElementById('select-all-ratings');

  function boxes() {
    return document.querySelectorAll('input[name="rating_ids[]"]');
  }

  function refresh() {
    var count = Array.prototype.filter.call(boxes(), function(box) { return box.checked; }).length;

    button.disabled = count === 0;
    button.textContent = count ? 'Delete Selected (' + count + ')' : 'Delete Selected';
    button.setAttribute('data-confirm',
      'Permanently delete ' + count + ' rating' + (count === 1 ? '' : 's') + '? This cannot be undone.');

    if (count === 0) selectAll.checked = false;
  }

  // The filters live outside the search form (form="ratings-search"), so
  // search.js does not see them; resubmit from the first page when they change.
  document.querySelectorAll('[form="ratings-search"]').forEach(function(el) {
    el.addEventListener('change', function() {
      search.querySelector('#page').value = '0';
      Rails.fire(search, 'submit');
    });
  });

  document.addEventListener('change', function(e) {
    if (e.target.name === 'rating_ids[]') refresh();
  });

  selectAll.addEventListener('change', function() {
    boxes().forEach(function(box) { box.checked = selectAll.checked; });
    refresh();
  });

  document.addEventListener('ratings:loaded', refresh);

  // Filtering happens over XHR, so the address bar does not know about it.
  // Carry the current filters through the delete so the page comes back as it was.
  bulk.addEventListener('submit', function() {
    var data = new FormData(search);
    document.getElementById('bulk_stars').value = data.get('stars') || '';
    document.getElementById('bulk_query').value = data.get('query') || '';
    document.getElementById('bulk_counted').value = data.get('counted') || '';
  });

  refresh();

});
